
import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  GetRoleTypeList,
  SaveRoleType,
  DelRoleType
} from '@/api/admin/permission'
@Component
export default class adminRole extends Vue {
  name = 'userAdmin_adminClass'
  GetRoleTypeList() {
    GetRoleTypeList({}).then(res => {
      this.table.total = res._param.total || 0
      this.table.data = res._param.list || []
    })
  }
  table = {
    data: [],
    total: 0,
    params: {
      page: 1,
      limit: 10
    },
    pageSizes: [10, 20, 30, 40],
    form: {
      show: false,
      params: { name: '', id: 0, sort: 0 },
      ref: 'admin_class_ref',
      rule: {
        name: [
          {
            required: true,
            trigger: 'blur',
            validator: (this as any).simpleVerify('请输入角色分类名称')
          }
        ]
      }
    },
    column: [
      {
        title: '序号',
        type: 'index',
        align: 'center',
        maxWidth: 100,
        minWidth: 50
      },
      {
        key: 'id',
        title: 'ID',
        align: 'center',
        minWidth: 60
      },
      {
        key: 'name',
        title: '分类名称',
        align: 'center',
        minWidth: 100
      },
      {
        key: 'option',
        title: '操作',
        align: 'center',
        minWidth: 150,
        render: (h, params) => {
          return h('div', [
            h(
              'Button',
              {
                props: { type: 'primary' },
                style: { paddingRight: '15px', paddingLeft: '15px' },
                on: {
                  click: () => {
                    this.table.form.params = {
                      ...params.row
                    }
                    this.table.form.show = true
                  }
                }
              },
              '编辑'
            ),
            h(
              'Button',
              {
                props: { type: 'error' },
                style: {
                  paddingRight: '15px',
                  paddingLeft: '15px',
                  marginLeft: '10px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '确认删除',
                      content:
                        "<p>是否确认删除此角色分类?<br><span style='color:red;font-size:12px'>若有该分类有角色,删除失败。</span></p>",
                      onOk: () => {
                        this.DelRoleType(params.row.id)
                      }
                    })
                  }
                }
              },
              '删除'
            )
          ])
        }
      }
    ]
  }
  limitchange() {}
  pagechange() {}
  //创建角色
  addClass() {
    this.table.form.show = true
    this.table.form.params.id = 0
    this.table.form.params.name = ''
  }
  @Watch('table.form.show')
  updateResize() {
    if (!this.table.form.show) {
      ;(this.$refs[this.table.form.ref] as any).resetFields()
    }
  }
  SaveRoleType() {
    ;(this.$refs[this.table.form.ref] as any).validate(valid => {
      if (valid) {
        SaveRoleType({ ...this.table.form.params }).then(res => {
          this.table.form.show = false
          this.GetRoleTypeList()
        })
      }
    })
  }
  DelRoleType(id) {
    DelRoleType({ id }).then(res => {
      this.GetRoleTypeList()
    })
  }
  created() {
    this.GetRoleTypeList()
  }

  mounted() {}
}
